import { createSubscriptionHook } from '~/shared/providers/api';

export const useScannerEventsSubscription = createSubscriptionHook(
  'iot.scannerEvents',
  () => ({
    iotScannerEvents: {
      id: true,
      name: true,
      status: true,
    },
  }),
  {
    select: ({ iotScannerEvents }) => iotScannerEvents,
  },
);
